export enum HttpCode {
  SUCCESS = 200,
  FORBIDDEN = 403,
  BAD_REQUEST = 400,
  UNAUTHORIZED = 401,
  SERVER_ERROR = 500,
}

export const KNOWN_ERROR_CODE = [HttpCode.SUCCESS, HttpCode.FORBIDDEN, HttpCode.BAD_REQUEST, HttpCode.UNAUTHORIZED]
